module.exports = "/9/1-structs/index.html.218b89a947ee10e7345fd63f614e71bf.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/33291.md
 ** module id = 579
 ** module chunks = 0
 **/